<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
		<br>
		<div class="col-lg-12">
			<div class="card card-danger card-outline collapsed-card">
		<div class="card-header">
			<div class="card-title">Data Filters</div>
			<div class="card-tools">
      <!-- Collapse Button -->
      <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
    </div>
		</div>
		<div class="card-body">
			<div class="col-lg-12 float-left">
				<div class="row">
					<div class="col-sm-4">
						<div class="form-group">
								<select class="form-control" v-model="params.sap_pushed">
									<option value="1">Yes</option>
									<option value="0">No</option>
								</select>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<select class="form-control" v-model="params.customer_type">
									<option value="b2c">B2C</option>
									<option value="b2b">B2B</option>
								</select>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<select class="form-control" v-model="params.payment_status">
									<option value="Pending">Pending</option>
									<option value="Completed">Completed</option>
								</select>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<select class="form-control" v-model="params.source">
									<option value="POS">POS</option>
									<option value="E-Commerce">E-Commerce</option>
									<option value="CARE">Service</option>
								</select>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<select class="form-control" v-model="params.delivery_mode">
									<option v-for="j in delivery_modes" :value="j.mode">{{j.mode}}</option>
								</select>
							</div>
					</div>
					<div class="col-sm-4" v-if='$gate.isZonalManager()'>
						<div class="form-group">
								<select class="form-control" v-model="params.branch">
									<option v-for="branch in branches" :value="branch.branch_code">{{branch.branch}}</option>
								</select>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<input type="date" class="form-control" v-model="params.from_date" placeholder="From date">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<input type="date" class="form-control" v-model="params.to_date" placeholder="To date">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<input class="form-control" placeholder="Enter a phone number" v-model="params.phone" type="number" min="1000000000">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<input class="form-control" placeholder="Enter SAP Doc Number" v-model="params.sapdoc" type="text">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<input class="form-control" placeholder="Enter gatepass" v-model="params.gatepass" type="number" min="1">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<input class="form-control" placeholder="Enter draft order no." v-model="params.draft_order_id" type="number" min="1">
							</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
						<div class="form-group">
								<button class="btn btn-primary" style="width:100% !important;" @click="getOrders('/api/getDraftOrders')">Search</button>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
							</div>
					</div>
				</div>
			</div>
		</div>
			</div>
		</div>
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-danger card-outline">
		<div class="card-body overflow-auto">
				<table class="table table-hover table-striped table-bordered">
						<thead class="thead-dark">
							<tr>
								<th scope="col">RequestID</th>
                                <th scope="col">Created By</th>
								<th scope="col">Customer Mobile</th>
								<th scope="col">Customer Name</th>
								<th scope="col">View</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="order in orders">
                                <td><p>{{order.id}}</p><p>APX: {{order.apx_bill_no}}</p></td>
                                <td>{{order.created_by.user_detail}}
                                <p>on {{order.created_at | smallDate}}</p></td>
								<td>{{order.phone_number}}</td>
								<td>{{order.customer_name}}</td>

								<td>
<!--									<button class="btn btn-danger" @click="view(order)" v-if="order.approved_by == null"">View</button>-->
									<button class="btn btn-primary" @click="edit(order)" v-if="order.approved_by == null"">Edit</button>
                                    <button class="btn btn-success" v-if="order.approved_by != null"">REQUEST APPROVED</button>
                                    <p v-if="order.approved_by != null">BY: {{order.approved_by.user_detail}}</p>
								</td>
							</tr>
						</tbody>
				</table>
    </div>
    <div class="card-footer">
			<pagination :pagination="pagination"
       	@prev="getOrders(pagination.prevPageUrl)"
        @next="getOrders(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

     		components: {pagination: Pagination},

        created(){
        	this.usertype = window.user.user_type;
        	this.getOrders();
        	// this.getDeliveryModes();
        	this.getBranches();
        },

        data(){
        	return{
        		orders: [],
        		results: '',
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
            	branch: ''
         		},

         		params: new Form({
         			sap_pushed: null,
         			customer_type: null,
         			delivery_mode: null,
         			phone: null,
         			sapdoc: null,
         			gatepass: null,
         			payment_status: null,
         			from_date: null,
         			to_date: null,
         			source: null,
         			draft_order_id: null
         		}),
         		delivery_modes: [],
         		branches : []
        	}
        },

        methods: {
        	getOrders(url="/api/getPurchaseRequests"){
        		axios.post(url, {results: this.results, params: this.params})
		      	.then(response => {
		      		this.orders = response.data.data.data;
		      		this.configPagination(response.data.data);
		      	})
		      },

		    //   getDeliveryModes(){
        	// 	axios.post("/api/getDeliveryModes")
        	// 	.then(response => {
        	// 		this.delivery_modes = response.data;
        	// 	});
        	// },

        	getBranches(){
        		if(this.usertype == 'zonal-manager'){
        			axios.post("/api/getZonalManagerBranches")
        			.then(response => {
        				this.branches = response.data;
        			});
        		}
        	},

		      configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

            view(order){
        		window.open('/purchase-request/'+order.id, "_blank");
        	},

        	edit(order){
        		window.open('/create-purchase-request/'+order.id+'/', "_blank");
        	},

    			reset(){
    				this.params.reset();
    				this.getOrders();
    			}
        }
    }
</script>
